import { Decimal } from 'decimal.js'

/** Display only: never use the rounded text for ledger calculations or writes. */
export function displayNumber(value: string | number | null | undefined): string {
  if (value == null || value === '') return '—'
  try {
    const number = new Decimal(value)
    return number.isFinite() ? number.toFixed(2, Decimal.ROUND_HALF_UP) : '—'
  } catch { return '—' }
}
